const STORAGE_ROOT = "/storage/";

// A chat's uploads, owned by that chat's branch alone: not part of a branch's
// stored data, so never copied, reset, or counted when deciding storage.
export const ATTACHMENTS_VOLUME = "3b-attachments";

export const UPLOADS_VOLUME = "3b-uploads";
// The orchestrator mounts this volume at UPLOADS_MOUNT_PATH for chat executions
// (`chat_uploads_mount` in services/orchestrator/src/executions/execution_store/normalize.rs).
export const UPLOADS_MOUNT_PATH = "/3b/uploads";

export function parseUploadPath(
  path: string
): { attachmentId: string; relativePath: string } | null {
  const prefix = `${UPLOADS_MOUNT_PATH}/`;
  if (!path.startsWith(prefix)) return null;
  const relativePath = path.slice(prefix.length);
  const segments = relativePath.split("/");
  if (
    segments.length !== 2 ||
    segments.some((segment) => ["", ".", ".."].includes(segment))
  ) {
    return null;
  }
  return { attachmentId: segments[0]!, relativePath };
}

export function parseStoragePath(
  path: string
): { volumeName: string; relativePath: string } | null {
  if (!path.startsWith(STORAGE_ROOT)) return null;
  const rest = path.slice(STORAGE_ROOT.length);
  const slash = rest.indexOf("/");
  if (slash <= 0) return null;
  const relativePath = rest.slice(slash + 1);
  const segments = relativePath.split("/");
  if (segments.some((segment) => ["", ".", ".."].includes(segment))) {
    return null;
  }
  return { volumeName: rest.slice(0, slash), relativePath };
}
